const CATEGORIES = [
  {
    id: 'luts',
    title: 'LUTs',
    description: 'Cinematic colour grading packs for film & video',
    image: '/images/shop/categories/luts.jpg',
  },
  {
    id: 'presets',
    title: 'PRESETS',
    description: 'Lightroom & Camera Raw presets for photography',
    image: '/images/shop/categories/presets.jpg',
  },
  {
    id: 'tutorials',
    title: 'TUTORIALS',
    description: 'Behind the scenes breakdowns & editing guides',
    image: '/images/shop/categories/tutorials.jpg',
  },
];

const PRODUCTS = [
  {
    id: 'cinematic-lut-pack-vol-1',
    title: 'CINEMATIC LUT PACK VOL. 1',
    price: 29.99,
    categoryId: 'luts',
    image: '/images/shop/products/lut-pack-01.jpg',
    images: [
      '/images/shop/products/lut-pack-01.jpg',
      '/images/shop/products/lut-pack-01-b.jpg',
    ],
    description:
      'A collection of 10 cinematic LUTs designed for live concert and event footage. Built from real-world grading sessions across arena tours and festival stages.',
    details: [
      '10 .cube LUT files',
      'Compatible with DaVinci Resolve, Premiere Pro, Final Cut Pro',
      'Designed for LOG and Rec.709 footage',
      'Instant download after purchase',
    ],
    featured: true,
  },
  {
    id: 'moody-concert-luts',
    title: 'MOODY CONCERT LUTs',
    price: 24.99,
    categoryId: 'luts',
    image: '/images/shop/products/lut-pack-02.jpg',
    images: [
      '/images/shop/products/lut-pack-02.jpg',
    ],
    description:
      'Dark, atmospheric grades for low-light concert environments. Handles mixed lighting and LED wash with ease.',
    details: [
      '8 .cube LUT files',
      'Optimised for low-light / high-ISO footage',
      'Works with all major NLEs',
      'Instant download after purchase',
    ],
    featured: true,
  },
  {
    id: 'live-show-preset-pack',
    title: 'LIVE SHOW PRESET PACK',
    price: 19.99,
    categoryId: 'presets',
    image: '/images/shop/products/preset-pack-01.jpg',
    images: [
      '/images/shop/products/preset-pack-01.jpg',
    ],
    description:
      'A set of 12 Lightroom presets tailored for live music photography. Designed to bring out stage lighting while maintaining natural skin tones.',
    details: [
      '12 Lightroom presets (.xmp)',
      'Compatible with Lightroom Classic & CC',
      'Mobile compatible',
      'Instant download after purchase',
    ],
    featured: true,
  },
];

const FAQ_ITEMS = [
  {
    question: 'What format are the LUTs in?',
    answer:
      'All LUTs are provided as .cube files, which are compatible with DaVinci Resolve, Adobe Premiere Pro, Final Cut Pro, and most other professional editing software.',
  },
  {
    question: 'Can I use these for commercial projects?',
    answer:
      'Yes — all products come with a commercial use license. You can use them on client work, YouTube videos, and any other professional projects.',
  },
  {
    question: 'How do I download my purchase?',
    answer:
      'After completing your purchase, you will receive a download link via email. You can also access your downloads from your order confirmation page.',
  },
  {
    question: 'Do you offer refunds?',
    answer:
      'Due to the digital nature of these products, refunds are not typically offered. If you experience any issues, please reach out and we will do our best to help.',
  },
  {
    question: 'What cameras are these LUTs designed for?',
    answer:
      'The LUTs are designed to work with LOG footage from any camera — including Sony, Canon, Blackmagic, RED, and more. Rec.709 compatible versions are also included.',
  },
];

export { CATEGORIES, PRODUCTS, FAQ_ITEMS };
